import IGlassWallGlass from 'components/interfaces/IGlassWallGlass';
import glassWallPartTypes from '../../../types/glassWallPartTypes';

const getDefaultGlassWallGlass = (id = 1): IGlassWallGlass => ({
  areaName: 'glass',
  endAngle: 0,
  glassAreaId: id,
  glassIds: [],
  glassWidths: [],
  individualGlassTypes: [],
  insertPosition: 0,
  startAngle: 0,
  totalAreaLength: 0,
  type: glassWallPartTypes.glass,
  typeName: 'Slidy30',
  /*
  // From here they are hardcoded fields
  woodyLeftElectricalBox: true,
  woodyRightElectricalBox: true,
  woodyLeftElectricalBoxWidth: 250,
  woodyRightElectricalBoxWidth: 250,
 */
});

export default getDefaultGlassWallGlass;
